import { IconButton, Menu, MenuItem } from '@mui/material';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import ListItemStyled from 'components/common/ListItemStyled';
import { useAnchorMenu } from 'hooks';
import useListParams from 'hooks/useListParams';
import { FC, useCallback } from 'react';

interface GroupItemProps {
  id: number;
  name: string;
  quantity: number;
  isAccessModify?: boolean;
  toggleDeleteGroup: () => void;
  toggleEditGroup: () => void;
}

const GroupItem: FC<GroupItemProps> = ({ toggleDeleteGroup, toggleEditGroup, id, name, quantity, isAccessModify }) => {
  const { anchor, isOpen, handleOpenMenu, handleCloseMenu } = useAnchorMenu();
  const { groupId, setGroupId } = useListParams();

  const handleChosen = useCallback(
    (id: string) => {
      setGroupId(id);
      isOpen && handleCloseMenu();
    },
    [isOpen, handleCloseMenu, setGroupId]
  );

  return (
    <>
      <ListItemStyled
        key={`flow:${id}.${name}.${quantity}`}
        selected={groupId === id.toString()}
        name={name}
        quantity={quantity}
        onClick={() => handleChosen(id.toString())}
        beforeElement={
          isAccessModify ? (
            <>
              <IconButton
                color={groupId === id.toString() ? 'primary' : 'default'}
                size="small"
                className={`beforeElement ${isOpen ? 'visible' : ''}`}
                sx={{ p: 0, width: 12, mr: 0.5 }}
                disableRipple
                disableFocusRipple
                disableTouchRipple
                onClick={(e) => {
                  handleOpenMenu(e);
                }}
              >
                <MoreVertIcon></MoreVertIcon>
              </IconButton>
              <Menu
                slotProps={{
                  paper: {
                    sx: { width: 218, ml: -1, mt: 0.5 },
                  },
                }}
                anchorEl={anchor}
                open={isOpen}
                onClose={handleCloseMenu}
                hideBackdrop
              >
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCloseMenu();
                    toggleEditGroup();
                  }}
                >
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCloseMenu();
                    toggleDeleteGroup();
                  }}
                >
                  Delete
                </MenuItem>
              </Menu>
            </>
          ) : null
        }
      />
    </>
  );
};

export default GroupItem;
